import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SelectBoxStyles } from '../../Components/helper';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function BomSubTypeMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const bomSubType = 'bom-sub-type';
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { BOMTypeList, BOMSubTypeList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingBSTM, setIsLoadingBSTM] = useState(false);
  const [showBomType, setShowBomType] = useState(false);
  const [isBomTypeUnique, setIsBomTypeUnique] = useState(true);
  const [buttonDownBomType, setButtonDownBomType] = useState(true);
  const [addingBTD, setAddingBTD] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isBOMST, setIsBOMST] = useState(false);
  const [bomSubTypeData, setBomSubTypeData] = useState([]);
  const [isUniqBTDId, setIsUniqBTDId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [bomSubTypeSelectData, setbomSubTypeSelectData] = useState(null);
  const [scrollEl, setScrollEl] = useState();
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'bomSubTypes', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'bomSubTypes', 'delete');
  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  useEffect(() => {
    setBomSubTypeData(BOMSubTypeList);
    if (addingBTD) {
      setBomSubTypeData([
        ...BOMSubTypeList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [BOMSubTypeList, addingBTD]);

  const callApi = async () => {
    setButtonDownBomType(!buttonDownBomType);
    setIsLoadingBSTM(true);
    buttonDownBomType ? setShowBomType(true) : setShowBomType(false);
    const bomTypeparams = {
      isAllRecord: true,
    };
    !bomSubTypeData.length && (await dispatch(action.getBOMTypeDetails(bomTypeparams)));
    setIsLoadingBSTM(false);
  };

  const handleChanged = (event, i) => {
    const bomST = [...bomSubTypeData];
    bomST[i] = {
      ...bomST[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    setIsBomTypeUnique(true);
    setIsUniqBTDId([]);
    const BtDarray = [];
    const BTDarrayIndex = [];
    bomST?.forEach((ele, ind) => {
      bomST?.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          BtDarray.push(ele);
          BTDarrayIndex.push(index);
        }
      });
    });
    if (!isEmpty(BtDarray)) {
      const arrs = [...BTDarrayIndex];
      const removeArss = Math.min(...arrs);
      const newArr = BTDarrayIndex.filter((ele) => ele !== removeArss);
      setIsUniqBTDId([...newArr]);
    }
    setIsBomTypeUnique(isEmpty(BtDarray));
    setBomSubTypeData(bomST);
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      bomSubTypeData.splice(id, 1);
      setIsBomTypeUnique(true);
      setIsUniqBTDId([]);
      setBomSubTypeData([...bomSubTypeData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const bomSubTypeCalled = async () => {
    const bomsubTypeParams = {
      bomTypeId: bomSubTypeSelectData._id,
      loggedInUserId,
    };
    await dispatch(action.getBOMSubTypeDetails(bomsubTypeParams));
  };

  const saveBOMST = async () => {
    setIsBOMST(true);
    if (!isEmpty(bomSubTypeData)) {
      const emptyField = await bomSubTypeData.filter((bomsitem) => bomsitem.name === null || bomsitem.name === '');

      if (isEmpty(emptyField)) {
        const data = bomSubTypeData.map((bomstobj) => {
          return { ...bomstobj, name: bomstobj?.name?.trim() };
        });
        const bomstparams = {
          loggedInUserId,
          bomTypeId: bomSubTypeSelectData._id,
          bomSubTypes: JSON.stringify(data),
          title: bomSubType,
        };
        setAddingBTD(false);
        await dispatch(action.saveToSystemMaster(bomstparams, t));
        await bomSubTypeCalled();
        // post API
      } else {
        const newState = bomSubTypeData.map((bomsobj) => (bomsobj?.isEmpty === false && bomsobj.name === null ? { ...bomsobj, isEmpty: true } : bomsobj));
        setBomSubTypeData(newState);
      }
    }
    setIsBOMST(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const bomTypeDataParams = {
      loggedInUserId,
      bomSubtypeId: deleteId,
      title: bomSubType,
    };
    await dispatch(action.deleteFromSystemMasters(bomTypeDataParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setBomSubTypeData([...BOMSubTypeList]);
    await bomSubTypeCalled();
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let btd = {};
    bomSubTypeData?.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: bomSubType,
        };
        btd = data;
      }
    });
    await dispatch(action.setActiveInactive(btd, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setBomSubTypeData([...bomSubTypeData]);
  };

  useEffect(() => {
    bomSubTypeSelectData && Object.keys(bomSubTypeSelectData).length && bomSubTypeCalled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomSubTypeSelectData]);

  useEffect(() => {
    const array = [];
    bomSubTypeData?.forEach((ele, index) => {
      bomSubTypeData?.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsBomTypeUnique(isEmpty(array));
      setIsUniqBTDId([]);
    }
  }, [bomSubTypeData]);

  const addBOMST = async () => {
    if (!showBomType) {
      setAddingBTD(true);
      setButtonDownBomType(!buttonDownBomType);
      setIsLoadingBSTM(true);
      buttonDownBomType ? setShowBomType(true) : setShowBomType(false);
      const bomTypeparams = {
        isAllRecord: true,
      };
      isEmpty(bomSubTypeData) && (await dispatch(action.getBOMTypeDetails(bomTypeparams)));
      setIsLoadingBSTM(false);
    } else if (!isEmpty(bomSubTypeData)) {
      setBomSubTypeData([...bomSubTypeData, tempObj]);
    } else {
      setBomSubTypeData([tempObj]);
    }
  };

  const btnCall = () => {
    if (buttonDownBomType === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const renderTooltipOpenCloseBomType = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownBomType ? 'Close' : 'Open'}
    </Tooltip>
  );

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('BOM_TYPE_MASTER.ACTIVATE_INACTIVATE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('BOM_TYPE_MASTER.DELETE')}
    </Tooltip>
  );

  const handleDropdownChangeBomType = (value) => {
    setbomSubTypeSelectData(value);
  };

  const saveBmst = () => {
    return isBOMST ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('BOM_TYPE_MASTER.SAVE')}
      </>
    );
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('BOM_TYPE_MASTER.BOM_SUB_TYPE_MASTER')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd onBtnClick={addBOMST} forDisable={!isBomTypeUnique} addEditAccess={MasterAddEditAccess} />
              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseBomType}>
                <button type="button" onClick={() => callApi()}>
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showBomType &&
            (isLoadingBSTM ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={[...BOMTypeList]}
                    placeholder={t('BOM_TYPE_MASTER.SELECT_BOM_TYPE')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    name="bomsubtype"
                    value={bomSubTypeSelectData}
                    styles={SelectBoxStyles}
                    onChange={handleDropdownChangeBomType}
                  />
                </div>
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  <ul>
                    {bomSubTypeSelectData &&
                      Object.keys(bomSubTypeSelectData).length !== 0 &&
                      !isEmpty(bomSubTypeData) &&
                      bomSubTypeData.map((boms, bomsIndex) => {
                        return (
                          <li key={boms?._id}>
                            <div className="input-container">
                              <input
                                name="bomTypeData"
                                value={boms?.name ? boms?.name : ''}
                                type="text"
                                autoFocus={!boms?._id}
                                placeholder={t('BOM_TYPE_MASTER.ENTER_BOM_SUB_TYPE')}
                                onChange={(e) => handleChanged(e, bomsIndex)}
                              />
                              {!isEmpty(isUniqBTDId) && isUniqBTDId.includes(bomsIndex) && (
                                <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.ENTRY_ALREADY_EXIST')}</label>
                              )}

                              {boms?.isEmpty && (boms?.name === null || boms?.name === '') && (
                                <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.BOM_SUB_TYPE_REQUIRED')}</label>
                              )}
                              {boms?.isNew && !isEmpty(boms?.name) && isEmpty(boms?.name?.trim()) && (
                                <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.INVALID_BOM_SUB_TYPE')}</label>
                              )}
                            </div>
                            <div className="input-action">
                              {boms?._id !== '' && MasterAddEditAccess && (
                                <OverlayTrigger placement={t('BOM_TYPE_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                  <button onClick={() => activeInactiveClicked(boms?._id)} id={boms?._id}>
                                    <span className={boms.isActive ? 'icon-active' : 'icon-inactive'} />
                                  </button>
                                </OverlayTrigger>
                              )}
                              {MasterDeleteAccess && (
                                <OverlayTrigger placement={t('BOM_TYPE_MASTER.AUTOS')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                  <button
                                    onClick={() => {
                                      handleDelete(boms?._id ? boms?._id : bomsIndex);
                                    }}
                                  >
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
                <div className="section-save">
                  {MasterAddEditAccess && (
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button aria-label="Save" className="btn btn-page-filter btn-white" onClick={saveBOMST} disabled={!isBomTypeUnique}>
                        {saveBmst()}
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('BOM_TYPE_MASTER.DELETE_FROM_SYSTEM_MASTER')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_DELETE_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('BOM_TYPE_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_ACTIVATE_DEACTIVATE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default BomSubTypeMaster;
